export function isVisible(elem) {
  const bounding = elem.getBoundingClientRect();

  return bounding.width > 0 && bounding.height > 0;
}
